import { gql } from '@apollo/client';
const UPDATE_PRODUCT_COUNTRY = gql `
  mutation UpdateProductCountry(
    $productCountryId: ID!
    $name: String!
    $description: String
    $continentId: ID
  ) {
    updateProductCountry(
      productCountryId: $productCountryId
      name: $name
      description: $description
      continentId: $continentId
    ) {
      productCountry {
        id
        name
        description
        continent {
          id
          name
        }
      }
    }
  }
`;
export default UPDATE_PRODUCT_COUNTRY;
